import * as React from 'react';
import type { StatusProps } from '../Status/Status';
import Status from '../Status/Status';
import type { StatusType } from '../../../types/Field';
import cn from '~modules/cn';
import Style from './object-status.module.scss';

const StatusMap: Record<StatusType, StatusProps> = {
    added: {
        text: 'New',
        type: 'active'
    },
    modified: {
        text: 'Changed',
        type: 'primary'
    },
    published: {
        text: 'Published',
        type: 'staled'
    },
    deleted: {
        text: 'Deleted',
        type: 'disabled'
    }
};

export default function ObjectStatus(props: { status: StatusType; showStaledStatus?: boolean; spacing?: 'bottom' | 'top'; className?: string }) {
    const statusProps = StatusMap[props.status];
    if (['published', 'deleted'].includes(props.status) && !props.showStaledStatus) {
        return null;
    }

    return (
        <Status
            className={cn(
                Style['object-status'],
                {
                    [Style['object-status-bottom-spacing']]: props.spacing === 'bottom',
                    [Style['object-status-top-spacing']]: props.spacing === 'top'
                },
                props.className
            )}
            text={statusProps.text}
            type={statusProps.type}
        />
    );
}
